// eslint-disable-next-line
import React, { Component } from 'react';
import ErrorScreen from 'components/Screen/ErrorScreen';

class ErrorBoundary extends Component {
  state: {
    error: any;
    errorInfo: any;
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: '',
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
  }

  render() {
    return this.state.error ? (
      <ErrorScreen fullScreen errorDetail={this.state.error.toString()} />
    ) : (
      this.props.children
    );
  }
}

export default ErrorBoundary;
